import React from "react";

import { Card, Stack, Typography } from "@mui/material";

import AppLayout from "../common/AppLayout";
import ListOfEpisodesSharedWithMe from "./components/ListOfEpisodesSharedWithMe";

export default function EpisodeSharedWithMeView() {
  return (
    <AppLayout pageName="Episodes Shared With Me" maxWidth={false}>
      <Card
        component={Stack}
        spacing={0}
        direction="column"
        sx={{ position: "relative", px: 4, py: 4, borderRadius: 2 }}
      >
        <Typography variant="h5" component="h1" sx={{ mb: 2 }}>
          List of Episodes that others have shared with me
        </Typography>
        <ListOfEpisodesSharedWithMe />
      </Card>
    </AppLayout>
  );
}
